import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ry_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const WHATSAPP_NUMBER = "7045444433";
export const WHATSAPP_LINK = (text = "") =>
  `https://wa.me/91${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
export const CONTACT_EMAIL = "contact@royaleyaan.com";

export const formatINR = (n) => {
  if (n == null) return "—";
  const num = Number(n);
  if (num >= 10000000) return `₹ ${(num / 10000000).toFixed(2)} Cr`;
  if (num >= 100000) return `₹ ${(num / 100000).toFixed(2)} L`;
  return `₹ ${num.toLocaleString("en-IN")}`;
};

export const formatKM = (n) =>
  n == null ? "—" : `${Number(n).toLocaleString("en-IN")} km`;

export default api;
